import React, { useState, useEffect, useCallback } from "react";
import {
  Radio,
  Table,
  Modal,
  Button,
  InputNumber,
  Cascader,
  Card,
  notification,
  Input,
} from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExceptionOutlined,
  FileDoneOutlined,
  LoadingOutlined,
  EditOutlined,
  BarcodeOutlined,
} from "@ant-design/icons";
import axios from "axios";
import ServiceApi, { authUser } from "../../../../services/ServiceApi";
import { isMobile } from "react-device-detect";

const initSerialNumber = {
  visible: false,
  list: [],
};

export default function Sparepart(props) {
  const { jobData } = props;
  const [jobDetail] = jobData.result_job_detail ?? [null];
  const [jobAssetdetail] = jobData.result_assetdetail ?? [null];
  const jobAssignment = jobData.result_assignment ?? [];
  const [materials, setMaterials] = useState([]);
  const [returnMaterials, setReturnMaterials] = useState([]);
  const [options, setOptions] = useState([]);
  const [returnOptions, setReturnOptions] = useState([]);
  const auth = authUser();
  const [visibleModal, setVisibleModal] = useState(false);
  const [messeneModal, setMesseneModal] = useState(
    "Are you sure to save data ?"
  );
  const [isSuccess, setIsSuccess] = useState(false);
  const [isProgress, setIsProgress] = useState(false);
  const [isError, setIsError] = useState(false);

  const [serialNumber, setSerialNumber] = useState(initSerialNumber);
  const [returnSerialNumber, setReturnSerialNumber] =
    useState(initSerialNumber);

  const [plantAndSloc, setPlAntAndSloc] = useState({
    plantCode: "",
    storage: "",
  });
  const [reason, setReason] = useState(jobDetail.reason_not_stock ?? "");
  const [isLoadingReSendEMail, setIsLoadingReSendEMail] = useState(false);
  const Columns = [
    {
      title: "No.",
      dataIndex: "",
      key: "",
      width: "",
      align: "center",
      render: (value, row, index) => {
        return index + 1;
      },
    },
    {
      title: "Batch ID",
      dataIndex: "batch",
      key: "batch",
      render: (value, row, index) => {
        return value;
      },
    },
    {
      title: "Part Code",
      dataIndex: "materialCode",
      key: "materialCode",
      width: "20%",
      render: (value, row, index) => {
        // console.log("Part Code", value, row, index);
        if (row.type === "ADD") {
          return (
            <Cascader
              options={options}
              onChange={(value, selectedOptions) => {
                const materialSelect = options[value];
                // console.log("selectedOptions", selectedOptions[0]);
                // console.log("materialSelect", materialSelect);
                // onChangeCascader({ ...selectedOptions[0], index: index });
                onChangeCascader({ ...materialSelect, index: index });
              }}
              placeholder="Please select"
              showSearch={{ filterCascader }}
              style={{ width: "100%" }}
            />
          );
        }
        return (
          <div style={{ alignItems: "center", display: "flex" }}>
            {value}
            {(row.meins || row.unit) !== "M" && (
              <BarcodeOutlined
                style={{ marginLeft: 20, cursor: "pointer" }}
                onClick={() => {
                  let listSerialNumber;
                  const { serialNumbers } = row;

                  if (serialNumbers) {
                    listSerialNumber = [
                      ...serialNumbers,
                      ...Array.from(
                        { length: row.qty - serialNumbers.length },
                        (x, i) => ({
                          serialNumber: "",
                        })
                      ),
                    ];
                  } else {
                    listSerialNumber = Array.from(
                      { length: row.qty },
                      (x, i) => ({
                        serialNumber: "",
                      })
                    );
                  }

                  setSerialNumber({
                    ...serialNumber,
                    index: index,
                    // text: row.serialNumber,
                    materialCode: row.materialCode,
                    list: listSerialNumber,
                    visible: true,
                  });
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      title: "Part Balance",
      dataIndex: "quantity",
      key: "quantity",
      width: "20px",
      render: (value, row, index) => {
        if (value) {
          return `${value} ${row.meins || row.unit}`;
        }
        return value;
      },
    },
    {
      title: "Qty",
      dataIndex: "qty",
      key: "qty",
      width: "100px",
      align: "center",
      render: (value, row, index) => {
        if (row.type === "ADD" || row.isUpdate) {
          return (
            <InputNumber
              min={1}
              value={value}
              onChange={(value) => onChangeQty({ index: index }, value)}
            />
          );
        }
        return `${value} ${row.meins || row.unit}`;
      },
    },
    {
      title: "Description",
      dataIndex: "materialName",
      key: "materialName",
      width: "",
      render: (value, row, index) => {
        return value;
      },
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: "",
      align: "center",
      render: (value, row, index) => {
        return (
          <div>
            {((row.materialCode !== "" && row.type === "ADD") ||
              row.isUpdate) && (
              <CheckCircleOutlined
                style={{ color: "#52c41a", margin: "0 4px" }}
                onClick={() => onClickSubmit({ index: index })}
              />
            )}
            {row.type !== "ADD" && !row.isUpdate && (
              <EditOutlined
                style={{ margin: "0 4px" }}
                onClick={() => onClickEdit({ ...row, index: index })}
              />
            )}
            <CloseCircleOutlined
              style={{ color: "#eb2f96", margin: "0 4px" }}
              onClick={() => onClickDelete({ ...row, index: index })}
            />
          </div>
        );
      },
    },
  ];

  const ReturnColumns = [
    {
      title: "No.",
      dataIndex: "",
      key: "",
      width: "",
      align: "center",
      render: (value, row, index) => {
        return index + 1;
      },
    },
    {
      title: "Batch ID",
      dataIndex: "batch",
      key: "batch",
      render: (value, row, index) => {
        return value;
      },
    },
    {
      title: "Part Code",
      dataIndex: "materialCode",
      key: "materialCode",
      width: "20%",
      render: (value, row, index) => {
        // console.log("Part Code", value, row, index);
        if (row.type === "ADD") {
          return (
            <Cascader
              options={returnOptions}
              defaultValue={value === "" ? null : [value]}
              onChange={(value, selectedOptions) => {
                const materialSelect = returnOptions[value];
                // onChangeReturnCascader({ ...selectedOptions[0], index: index });
                onChangeReturnCascader({ ...materialSelect, index: index });
              }}
              placeholder="Please select"
              showSearch={{ filterCascader }}
              style={{ width: "100%" }}
            />
          );
        }
        return (
          <div style={{ alignItems: "center", display: "flex" }}>
            {value}
            {(row.meins || row.unit) !== "M" && (
              <BarcodeOutlined
                style={{ marginLeft: 20, cursor: "pointer" }}
                onClick={() => {
                  let listSerialNumber;
                  const { serialNumbers } = row;

                  if (serialNumbers) {
                    listSerialNumber = [
                      ...serialNumbers,
                      ...Array.from(
                        { length: row.qty - serialNumbers.length },
                        (x, i) => ({
                          serialNumber: "",
                        })
                      ),
                    ];
                  } else {
                    listSerialNumber = Array.from(
                      { length: row.qty },
                      (x, i) => ({
                        serialNumber: "",
                      })
                    );
                  }

                  setReturnSerialNumber({
                    ...returnSerialNumber,
                    index: index,
                    // text: row.serialNumber,
                    materialCode: row.materialCode,
                    list: listSerialNumber,
                    visible: true,
                  });
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      title: "Part Balance",
      dataIndex: "quantity",
      key: "quantity",
      width: "20px",
      render: (value, row, index) => {
        if (value) {
          return `${value} ${row.meins || row.unit}`;
        }
        return value;
      },
    },
    {
      title: "Qty",
      dataIndex: "qty",
      key: "qty",
      width: "100px",
      align: "center",
      render: (value, row, index) => {
        if (row.type === "ADD" || row.isUpdate) {
          return (
            <InputNumber
              min={1}
              value={value}
              onChange={(value) => onChangeReturnQty({ index: index }, value)}
            />
          );
        }
        return `${value} ${row.meins || row.unit}`;
      },
    },
    {
      title: "Description",
      dataIndex: "materialName",
      key: "materialName",
      width: "",
      render: (value, row, index) => {
        return value;
      },
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      width: "",
      align: "center",
      render: (value, row, index) => {
        return (
          <div>
            {((row.materialCode !== "" && row.type === "ADD") ||
              row.isUpdate) && (
              <CheckCircleOutlined
                style={{ color: "#52c41a", margin: "0 4px" }}
                onClick={() => onClickReturnSubmit({ index: index })}
              />
            )}
            {row.type !== "ADD" && !row.isUpdate && (
              <EditOutlined
                style={{ margin: "0 4px" }}
                onClick={() => onClickReturnEdit({ ...row, index: index })}
              />
            )}
            <CloseCircleOutlined
              style={{ color: "#eb2f96", margin: "0 4px" }}
              onClick={() => onClickReturnDelete({ ...row, index: index })}
            />
          </div>
        );
      },
    },
  ];

  const onClickDelete = (item) => {
    console.log(item);
    if (item.materialId) {
      ServiceApi.post("sapstock/savematerialstocks", {
        materials: [{ ...item, userName: auth.username, action: "DELETE" }],
        jobID: jobAssetdetail.job_id,
        reason: reason,
      })
        .then(({ data }) => {
          if (data.result.code === "P" || data.result.value === "P") {
            handleGetMaterials(jobAssetdetail.job_id);
            notification.success({
              message: "Success",
              description: "ลบรายการ Material สำเร็จ",
            });
          } else {
            setMesseneModal(data.result.showText);
            setIsProgress(false);
            setIsError(true);
          }
        })
        .catch((err) => {
          console.log(err);
          setIsProgress(false);
          setMesseneModal("data error");
        });
    } else {
      const newMaterials = materials.filter((s, i) => i !== item.index);
      setMaterials(newMaterials);
    }
  };

  const onClickReturnDelete = (item) => {
    console.log(item);
    if (item.materialId) {
      ServiceApi.post("sapstock/savematerialstocks", {
        materials: [
          { ...item, userName: auth.username, isReturn: 1, action: "DELETE" },
        ],
        jobID: jobAssetdetail.job_id,
        reason: reason,
      })
        .then(({ data }) => {
          if (data.result.code === "P" || data.result.value === "P") {
            handleGetReturnMaterials(jobAssetdetail.job_id);
            notification.success({
              message: "Success",
              description: "ลบรายการ Material สำเร็จ",
            });
          } else {
            setMesseneModal(data.result.showText);
            setIsProgress(false);
            setIsError(true);
          }
        })
        .catch((err) => {
          console.log(err);
          setIsProgress(false);
          setMesseneModal("data error");
        });
    } else {
      const newMaterials = returnMaterials.filter((s, i) => i !== item.index);
      setReturnMaterials(newMaterials);
    }
  };

  const onClickEdit = (item) => {
    if (item.materialId) {
      ServiceApi.post("sapstock/getstocks", {
        plantCode: item.plantCode,
        storage: item.storage,
        materialCode: item.materialCode,
      }).then(({ data: { data } }) => {
        const [material] = data;
        console.log("material", material);
        const newMaterials = materials.map((value, index) => {
          if (item.index === index) {
            return {
              ...value,
              quantity: material.quantity,
              action: value.type === "UPDATE" ? "UPDATE" : "ADD",
              isUpdate: true,
            };
          }
          return value;
        });
        setMaterials(newMaterials);
      });
    } else {
      const newMaterials = materials.map((value, index) => {
        if (item.index === index) {
          return {
            ...value,
            action: value.type === "UPDATE" ? "UPDATE" : "ADD",
            isUpdate: true,
          };
        }
        return value;
      });
      setMaterials(newMaterials);
    }
  };

  const onClickReturnEdit = (item) => {
    const material = returnOptions.find(
      (s) => s.materialCode === item.materialCode
    );
    const newMaterials = returnMaterials.map((value, index) => {
      if (item.index === index) {
        return {
          ...value,
          quantity: material?.qty ?? "",
          action: value.type === "UPDATE" ? "UPDATE" : "ADD",
          isUpdate: true,
        };
      }
      return value;
    });
    setReturnMaterials(newMaterials);
  };

  const onClickSubmit = (item) => {
    const newMaterials = materials.map((value, index) => {
      if (item.index === index) {
        return {
          ...value,
          lastBalance: value.quantity,
          quantity: null,
          type: "SUBMIT",
          isUpdate: false,
        };
      }
      return value;
    });
    setMaterials(newMaterials);
  };

  const onClickReturnSubmit = (item) => {
    const newMaterials = returnMaterials.map((value, index) => {
      if (item.index === index) {
        return {
          ...value,
          // lastBalance: value.quantity,
          quantity: null,
          type: "SUBMIT",
          isUpdate: false,
        };
      }
      return value;
    });
    setReturnMaterials(newMaterials);
  };

  const onChangeQty = (item, qty) => {
    const newMaterials = materials.map((value, index) => {
      if (item.index === index) {
        return {
          ...value,
          qty: qty,
        };
      }
      return value;
    });
    setMaterials(newMaterials);
  };

  const onChangeReturnQty = (item, qty) => {
    const newMaterials = returnMaterials.map((value, index) => {
      if (item.index === index) {
        return {
          ...value,
          qty: qty,
        };
      }
      return value;
    });
    setReturnMaterials(newMaterials);
  };

  const onChangeCascader = (item) => {
    const newMaterials = materials.map((value, index) => {
      if (item.index === index) {
        return {
          ...value,
          key: item.index,
          batch: item.batch,
          materialCode: item.materialCode,
          materialGroup: item.materialGroup,
          materialName: item.materialName,
          materialType: item.materialType,
          meins: item.meins,
          plantCode: item.plantCode,
          quantity: item.quantity,
          storage: item.storage,
        };
      }
      return value;
    });
    setMaterials(newMaterials);
  };

  const onChangeReturnCascader = (item) => {
    const newMaterials = returnMaterials.map((value, index) => {
      if (item.index === index) {
        return {
          ...value,
          key: item.index,
          batch: item.batch,
          materialCode: item.materialCode,
          // materialGroup: item.materialGroup,
          materialName: item.materialName,
          // materialType: item.materialType,
          meins: item.meins || item.unit,
          unit: item.unit,
          plantCode: item.plantCode,
          quantity: item.qty,
          storage: item.storage,
        };
      }
      return value;
    });
    setReturnMaterials(newMaterials);
  };

  const filterCascader = (inputValue, path) => {
    return path.some(
      (option) =>
        option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    );
  };

  const handleSave = () => {
    setIsProgress(true);
    const request = materials
      .filter((f) => f.type === "SUBMIT")
      .map((s) => {
        return {
          // sapId: "7201046036",
          sapId: jobDetail.sap_id,
          materialId: s.materialId,
          companyId: jobDetail.company_id,
          operatorId: jobDetail.operator_id,
          projectId: jobDetail.project_id,
          jobId: jobAssetdetail.job_id,
          materialCode: s.materialCode,
          materialName: s.materialName,
          qty: s.qty,
          unit: s.meins || s.unit,
          plantCode: s.plantCode,
          storage: s.storage,
          batch: s.batch,
          ReservationNo: s.reservationNo,
          ReservationItem: s.reservationItem,
          serialNumbers: s.serialNumbers,
          lastBalance: s.lastBalance,
          userName: auth.username,
          action: s.action,
        };
      });

    const requestReturn = returnMaterials
      .filter((f) => f.type === "SUBMIT")
      .map((s) => {
        return {
          // sapId: "7201046036",
          sapId: jobDetail.sap_id,
          materialId: s.materialId,
          companyId: jobDetail.company_id,
          operatorId: jobDetail.operator_id,
          projectId: jobDetail.project_id,
          jobId: jobAssetdetail.job_id,
          materialCode: s.materialCode,
          materialName: s.materialName,
          qty: s.qty,
          unit: s.meins || s.unit,
          plantCode: s.plantCode,
          storage: s.storage,
          batch: s.batch,
          ReservationNo: s.reservationNo,
          ReservationItem: s.reservationItem,
          serialNumbers: s.serialNumbers,
          // lastBalance: s.lastBalance,
          userName: auth.username,
          isReturn: 1,
          action: s.action,
        };
      });

    ServiceApi.post("sapstock/savematerialstocks", {
      materials: [...request, ...requestReturn],
      jobID: jobAssetdetail.job_id,
      reason: reason,
    })
      .then(({ data }) => {
        if (data.result.code === "P" || data.result.value === "P") {
          // setMaterials(request.map((s) => ({ ...s, type: "UPDATE" })));
          handleGetMaterials(jobAssetdetail.job_id);
          handleGetReturnMaterials(jobAssetdetail.job_id);
          setMesseneModal("Save data success");
          setIsSuccess(true);
          setIsProgress(false);
        } else {
          setMesseneModal(data.result.showText);
          setIsProgress(false);
          setIsError(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsProgress(false);
        setIsError(true);
        setMesseneModal("Save data error");
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleGetMaterials = async (jobId) => {
    var checkSub = "O";
    console.log("jobAssignment", jobAssignment);
    const findSub = jobAssignment?.find((s) => s.subflag === "O");

    if (!findSub) {
      notification.error({
        message: "เกิดข้อผิดพลาด",
        description: "ไม่สามารถหา Sub AckJob ได้",
      });
      checkSub = "C";
      return;
    }

    // if (!findSub.team_id) {
    //   notification.error({
    //     message: "เกิดข้อผิดพลาด",
    //     description: "ไม่พบ Team ID ใน Job นี้",
    //   });
    //   checkSub = "C";
    //   return;
    // }

    // const team = await ServiceApi.post(`master_data/get_team_sc_plant_sloc`, {
    //   company_id: jobDetail.company_id,
    //   operator_id: jobDetail.operator_id,
    //   project_id: jobDetail.project_id,
    //   team_id: findSub.team_id,
    //   emp_id: findSub.actjob_emp_id,
    //   team_group_duty : checkSub ,
    //   area_code : jobDetail.area_code
    // });
    let param = {};
    let api = "";
    if (jobDetail.operator_id === 18) {
      api = "master_data/get_emp_plant_sloc";
      param = {
        user_name: auth.username,
      };
    } else {
      api = "master_data/get_team_plant_sloc";
      param = {
        company_id: jobDetail.company_id,
        operator_id: jobDetail.operator_id,
        project_id: jobDetail.project_id,
        team_id: findSub.team_id,
        emp_id: findSub.actjob_emp_id,
      };
    }
    const team = await ServiceApi.post(api, param);

    const {
      data: { list },
    } = team;

    if (list.length <= 0) {
      notification.error({
        message: "เกิดข้อผิดพลาด",
        description: "ไม่พบ Sloc ในทีมที่ AckJob",
      });
      return;
    }

    const [dataTeam] = list;

    setPlAntAndSloc({ plantCode: dataTeam.plant, storage: dataTeam.sloc_name });
    axios
      .all([
        ServiceApi.get(`sapstock/getstockbyjobid?jobId=${jobId}`),
        ServiceApi.post("sapstock/getstocks", {
          plantCode: dataTeam.plant,
          storage: dataTeam.sloc,
          // plantCode: "H103",
          // storage: "7045",
          materialCode: "",
        }),
      ])
      .then(([resMaterials, resStocks]) => {
        const {
          data: { data: resultMaterials },
        } = resMaterials;
        const {
          data: { data: resultStocks },
        } = resStocks;

        if (resultStocks.length <= 0) {
          notification.error({
            message: "เกิดข้อผิดพลาด",
            description: `ไม่พบรายการ Material ที่ Plant :${dataTeam.plant} และ Sloc : ${dataTeam.sloc}`,
          });
        }

        // const materialCodeList = resultMaterials.map((s) => s.materialCode);
        // const filterStocks = resultStocks.filter(
        //   (s) => !materialCodeList.includes(s.materialCode)
        // );

        setMaterials(
          resultMaterials.map((s, i) => ({
            ...s,
            key: i,
            type: "UPDATE",
            isUpdate: false,
          }))
        );
        setOptions(
          resultStocks.map((s, i) => ({
            ...s,
            value: i,
            label: `${s.batch} ${s.materialCode}`,
            disabled: s.quantity <= 0,
          }))
        );

        setReturnOptions(
          resultStocks.map((s, i) => ({
            ...s,
            value: i,
            label: `${s.batch} ${s.materialCode}`,
            disabled: s.quantity <= 0,
          }))
        );
        // setReturnOptions(
        //   resultMaterials.map((s, i) => ({
        //     ...s,
        //     value: s.materialCode,
        //     label: `${s.batch} ${s.materialCode}`,
        //   }))
        // );
      });
  };

  const handleGetReturnMaterials = (jobId) => {
    ServiceApi.get(`sapstock/getreturnstockbyjobid?jobId=${jobId}`).then(
      (res) => {
        const {
          data: { data: result },
        } = res;
        setReturnMaterials(
          result.map((s, i) => ({
            ...s,
            key: i,
            type: "UPDATE",
            isUpdate: false,
          }))
        );
      }
    );
  };

  const onChangeSerialNumber = (item, list) => {
    const newMaterials = materials.map((value, index) => {
      if (item.index === index) {
        return {
          ...value,
          serialNumbers: list,
          action: value.type === "UPDATE" ? "UPDATE" : "ADD",
          type: "SUBMIT",
        };
      }
      return value;
    });
    setMaterials(newMaterials);
  };

  const onChangeReturnSerialNumber = (item, list) => {
    const newMaterials = returnMaterials.map((value, index) => {
      if (item.index === index) {
        return {
          ...value,
          serialNumbers: list,
          action: value.type === "UPDATE" ? "UPDATE" : "ADD",
          type: "SUBMIT",
        };
      }
      return value;
    });
    setReturnMaterials(newMaterials);
  };

  const handleReSendEmail = () => {
    setIsLoadingReSendEMail(true);
    ServiceApi.post("job_detail/send_mail", {
      company_id: jobDetail.company_id,
      operator_id: jobDetail.operator_id,
      project_id: jobDetail.project_id,
      job_id: jobAssetdetail.job_id,
    })
      .then(({ data }) => {
        setIsLoadingReSendEMail(false);
        if (data.result.code === "P" || data.result.value === "P") {
          notification.success({
            message: "Success",
            description: data.result.description,
          });
        } else {
          notification.error({
            message: "เกิดข้อผิดพลาด",
            description: data.result.description,
          });
        }
      })
      .catch((err) => {
        setIsLoadingReSendEMail(false);
        console.log(err);
        notification.error({
          message: "เกิดข้อผิดพลาด",
          description: err.message,
        });
      });
  };

  useEffect(() => {
    handleGetMaterials(jobAssetdetail.job_id);
    handleGetReturnMaterials(jobAssetdetail.job_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobAssetdetail]);

  useEffect(() => {
    console.log("jobDetail", jobDetail);
  }, [jobDetail]);

  return (
    <>
      <div className={`container ${isMobile ? "pl-0 pr-0" : ""}`}>
        <div
          className="d-flex"
          style={{ justifyContent: "flex-end", marginBottom: 10 }}
        >
          <div style={{ width: 140, paddingLeft: 10 }}>
            <Input
              className="material-sloc"
              addonBefore="PLANT"
              value={plantAndSloc.plantCode}
              disabled
              size="small"
            />
          </div>
          <div style={{ width: 140, paddingLeft: 10 }}>
            <Input
              className="material-sloc"
              addonBefore="SLOC"
              value={plantAndSloc.storage}
              disabled
              size="small"
            />
          </div>
        </div>
        <Card
          title="เบิกอุปกรณ์"
          headStyle={{ fontSize: 21, color: "#000f9f" }}
          size="small"
        >
          <div className={`col-12 mt-2 mx-auto ${isMobile ? "pl-0 pr-0" : ""}`}>
            <div
              className="row mt-3"
              style={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <Radio.Group
                name="sparepart"
                value={materials.length > 0 ? 1 : 2}
              >
                <Radio value={1}>
                  <span className="font-thai-r c-blue fs-20">เบิกอุปกรณ์</span>
                </Radio>
                <Radio value={2}>
                  <span className="font-thai-r c-blue fs-20">
                    ไม่เบิกอุปกรณ์
                  </span>
                </Radio>
              </Radio.Group>
              <div>
                <button
                  className="btn btn-warning pl-4 pr-4 pt-2 pb-2 mr-2"
                  onClick={() =>
                    setMaterials([
                      ...materials,
                      {
                        key: materials.length,
                        type: "ADD",
                        materialId: "",
                        companyId: "",
                        operatorId: "",
                        projectId: "",
                        jobId: "",
                        materialCode: "",
                        materialName: "",
                        sapId: "",
                        qty: 1,
                        unit: "",
                        action: "ADD",
                        plantCode: "",
                        storage: "",
                        batch: "",
                      },
                    ])
                  }
                >
                  Add Material
                </button>
              </div>
            </div>
            <div className="row">
              <Table
                columns={Columns}
                agination={{ pageSize: 5 }}
                style={{ width: "100%" }}
                dataSource={materials}
                scroll={{ x: 1000 }}
              />
            </div>
          </div>
        </Card>
        <div style={{ border: "1px solid #dfdfdf", margin: "1.5rem 0px" }} />
        <Card
          title="คืนอุปกรณ์"
          headStyle={{ fontSize: 21, color: "#000f9f" }}
          size="small"
        >
          <div className={`col-12 mt-2 mx-auto ${isMobile ? "pl-0 pr-0" : ""}`}>
            <div
              className="row mt-3"
              style={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <Radio.Group
                name="sparepart"
                value={returnMaterials.length > 0 ? 1 : 2}
              >
                <Radio value={1}>
                  <span className="font-thai-r c-blue fs-20">คืนอุปกรณ์</span>
                </Radio>
                <Radio value={2}>
                  <span className="font-thai-r c-blue fs-20">
                    ไม่คืนอุปกรณ์
                  </span>
                </Radio>
              </Radio.Group>
              <div>
                <button
                  className="btn btn-warning pl-4 pr-4 pt-2 pb-2 mr-2"
                  onClick={() =>
                    setReturnMaterials([
                      ...returnMaterials,
                      {
                        key: materials.length,
                        type: "ADD",
                        materialId: "",
                        companyId: "",
                        operatorId: "",
                        projectId: "",
                        jobId: "",
                        materialCode: "",
                        materialName: "",
                        sapId: "",
                        qty: 1,
                        unit: "",
                        action: "ADD",
                        plantCode: "",
                        storage: "",
                        batch: "",
                      },
                    ])
                  }
                >
                  Add Material
                </button>
              </div>
            </div>
            <div className="row">
              <Table
                columns={ReturnColumns}
                agination={{ pageSize: 5 }}
                style={{ width: "100%" }}
                dataSource={returnMaterials}
                scroll={{ x: 1000 }}
              />
            </div>
          </div>
        </Card>
        <div style={{ border: "1px solid #dfdfdf", margin: "1.5rem 0px" }} />
        {materials.length === 0 && (
          <div className="row mb-3">
            <div className="col-12">
              <div className="row">
                <span className="font-thai-r fs-18">
                  เหตุผลที่ไม่เบิกอุปกรณ์
                </span>
              </div>
              <div className="row">
                <Input.TextArea
                  name="employmentReason"
                  className="inputfile c-blue"
                  value={reason}
                  rows={4}
                  onChange={(e) => {
                    const { value } = e.target;
                    setReason(value);
                  }}
                />
              </div>
            </div>
          </div>
        )}

        <div className="row justify-content-between" style={{ marginTop: 10 }}>
          <div className="col-auto">
            <Button
              loading={isLoadingReSendEMail}
              onClick={() => {
                handleReSendEmail();
                // if (!jobDetail.sap_id) {
                //   notification.error({
                //     message: "เกิดข้อผิดพลาด",
                //     description:
                //       "ไม่สามารถจองอะไหล่ได้เนื่องจากยังไม่มีหมายเลข Sap ID",
                //   });
                //   return;
                // }
                // setVisibleModal(true);
              }}
            >
              Re-Send Email
            </Button>
          </div>
          <div className="col-auto">
            <Button
              type="primary"
              onClick={() => {
                if (!jobDetail.sap_id) {
                  notification.error({
                    message: "เกิดข้อผิดพลาด",
                    description:
                      "ไม่สามารถจองอะไหล่ได้เนื่องจากยังไม่มีหมายเลข Sap ID",
                  });
                  return;
                }
                setVisibleModal(true);
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
      <Modal
        title={null}
        centered
        visible={visibleModal}
        footer={null}
        closable={false}
      >
        <div className="text-center">
          {isProgress ? (
            <LoadingOutlined style={{ fontSize: "50px", color: "#1890ff" }} />
          ) : (
            <>
              {isSuccess ? (
                <FileDoneOutlined
                  style={{ fontSize: "50px", color: "#52c41a" }}
                />
              ) : (
                <ExceptionOutlined
                  style={{ fontSize: "50px", color: "#e8cd00" }}
                />
              )}
            </>
          )}

          <h3 className="font-mont-sb fs-18 c-blue mt-3">{messeneModal}</h3>
          {!isSuccess && (
            <button
              onClick={() => handleSave()}
              className="btn btn-secondary"
              style={{ color: "#0500a3", backgroundColor: "#e8cd00" }}
            >
              Submit
            </button>
          )}

          <button
            onClick={() => {
              setVisibleModal(false);
              setIsProgress(false);
              setIsSuccess(false);
              setMesseneModal("Are you sure to save data ?");
            }}
            className="btn btn-secondary"
          >
            Close
          </button>
        </div>
      </Modal>
      <Modal
        title={`Part Code : ${serialNumber.materialCode}`}
        // title={"Serial Number"}
        centered
        visible={serialNumber.visible}
        closable={false}
        onOk={() => {
          onChangeSerialNumber(serialNumber, serialNumber.list);
          setSerialNumber(initSerialNumber);
        }}
        onCancel={() => {
          setSerialNumber(initSerialNumber);
        }}
      >
        <div className="text-center">
          {serialNumber.list.map((item, index) => (
            <div className="row mb-2 align-items-center" key={index}>
              <div className="col-auto">
                <label htmlFor="serialNumber" className="col-form-label">
                  {`Serial Number ${index + 1} :`}
                </label>
              </div>
              <div className="col">
                <Input
                  value={item.serialNumber}
                  onChange={(e) => {
                    const { value } = e.target;
                    setSerialNumber({
                      ...serialNumber,
                      list: serialNumber.list.map((s, i) => {
                        if (i === index) {
                          return { ...s, serialNumber: value };
                        }
                        return s;
                      }),
                    });
                    // console.log();
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </Modal>
      <Modal
        title={`Part Code : ${returnSerialNumber.materialCode}`}
        // title={"Serial Number"}
        centered
        visible={returnSerialNumber.visible}
        closable={false}
        onOk={() => {
          onChangeReturnSerialNumber(
            returnSerialNumber,
            returnSerialNumber.list
          );
          setReturnSerialNumber(initSerialNumber);
        }}
        onCancel={() => {
          setReturnSerialNumber(initSerialNumber);
        }}
      >
        <div className="text-center">
          {returnSerialNumber.list.map((item, index) => (
            <div className="row mb-2 align-items-center" key={index}>
              <div className="col-auto">
                <label htmlFor="serialNumber" className="col-form-label">
                  {`Serial Number ${index + 1} :`}
                </label>
              </div>
              <div className="col">
                <Input
                  value={item.serialNumber}
                  onChange={(e) => {
                    const { value } = e.target;
                    setReturnSerialNumber({
                      ...returnSerialNumber,
                      list: returnSerialNumber.list.map((s, i) => {
                        if (i === index) {
                          return { ...s, serialNumber: value };
                        }
                        return s;
                      }),
                    });
                    // console.log();
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
}
